import dayjs from "dayjs";

export const formatRecommendTicket = (param) => {
  const obj = {};
  obj.plan = `买${param.from_station_name}-${param.to_station_name}，`;
  if (param.type == 1) {
    // 出发站多买
    obj.tips = `多买${param.diff_station_num}站`;
    obj.plan += "多付";
    obj.price = `￥${param.diff_amount / 100}`;
  } else if (param.type == 2) {
    // 到达站多买
    obj.tips = `多买${param.diff_station_num}站`;
    obj.plan += "多付";
    obj.price = `￥${param.diff_amount / 100}`;
  } else if (param.type == 3) {
    // 到达站少买
    obj.tips = "上车补票";
    obj.plan += "上车后";
    obj.diffStationNum = `补${param.diff_station_num}站`;
  }
  return obj;
};

export const formatRecommendTicketDrawer = (param) => {
  const recommend = param.recommend_ticket?.length
    ? param.recommend_ticket[0]
    : param.recommend_ticket;
  const obj = {};
  const weeks = ["日", "一", "二", "三", "四", "五", "六"];
  const time = dayjs(param.start_time);
  obj.info = `${time.format("M月D号")} 周${weeks[time.day()]} ${
    param.train_code
  }`;
  const ticket_price = recommend.ticket_price / 100;
  const coupon_after_price = recommend?.coupon_after_price /100 || ''
  const seat_name = recommend.seat_type_name;

  obj.price = ticket_price;
  obj.afterPrice = coupon_after_price
  obj.desc = recommend.discount_desc

  obj.guide = formatRecommendTicketGuide(param, true);

  if (recommend.type == 1) {
    // 出发站多买
    obj.title = `同车次有票，仅多买${recommend.diff_station_num}站`;
    obj.tag = `多买${recommend.diff_station_num}站`;
    obj.tips = `买${recommend.from_station_name}-${
      recommend.to_station_name
    }，您仍可以在${
      param.from_station_name
    }上车，多付{{￥${recommend.diff_amount / 100}}}`;
    obj.orderTips = `买${recommend.from_station_name}-${
      recommend.to_station_name
    }，${param.from_station_name}上车多付{{￥${recommend.diff_amount / 100}}}`;
    obj.highlight = "#FF6400";
    obj.seat = seat_name + `￥${ticket_price}`;
  } else if (recommend.type == 2) {
    // 到达站多买
    obj.title = `同车次有票，仅多买${recommend.diff_station_num}站`;
    obj.tag = `多买${recommend.diff_station_num}站`;
    obj.tips = `买${recommend.from_station_name}-${
      recommend.to_station_name
    }，您仍可以在${param.to_station_name}下车，多付{{￥${recommend.diff_amount /
      100}}}`;
    obj.orderTips = `买${recommend.from_station_name}-${
      recommend.to_station_name
    }，${param.from_station_name}下车多付{{￥${recommend.diff_amount / 100}}}`;
    obj.highlight = "#FF6400";
    obj.seat = seat_name + `￥${ticket_price}`;
  } else if (recommend.type == 3) {
    // 到达站少买
    obj.title = `同车次有票，上车后补${recommend.diff_station_num}站`;
    obj.tag = "上车补票";
    obj.tips = `买${recommend.from_station_name}-${recommend.to_station_name}，上车后找列车员{{补${recommend.diff_station_num}站}}到${param.to_station_name}`;
    obj.orderTips = `买${recommend.from_station_name}-${recommend.to_station_name}，上车后{{补${recommend.diff_station_num}站}}到${param.to_station_name}`;
    obj.highlight = "#338FFF";
    obj.seat = seat_name + `￥${ticket_price}`;
  }
  return obj;
};

export const formatRecommendTicketGuide = (param, needTime = false) => {
  const isExpectTicket = param.expect_ticket;
  const recommend = param.recommend_ticket?.length
    ? param.recommend_ticket[0]
    : param.recommend_ticket;
  let guide = {};
  if (recommend) {
    guide = {
      type: recommend.type,
      tips: "",
      list: [],
    };
    const start_time = dayjs(param.start_time);
    const arrive_time = dayjs(param.arrive_time);
    const startTime = needTime
      ? ("0" + start_time.hour()).slice(-2) +
        ":" +
        ("0" + start_time.minute()).slice(-2)
      : "";
    const arriveTime = needTime
      ? ("0" + arrive_time.hour()).slice(-2) +
        ":" +
        ("0" + arrive_time.minute()).slice(-2)
      : "";
    if (recommend.type == 1) {
      // 出发站多买
      guide.tips = `多买${recommend.diff_station_num}站`;
      guide.list = [
        {
          time: "",
          station: isExpectTicket
            ? param.from_station_name
            : recommend.from_station_name,
          tips: "",
        },
        {
          line: true,
          text: guide.tips,
        },
        {
          time: startTime,
          station: isExpectTicket
            ? recommend.expect_from_station
            : param.from_station_name,
          tips: "上车",
        },
        {
          line: true,
          text: "",
        },
        {
          time: arriveTime,
          station: isExpectTicket
            ? recommend.expect_to_station
            : param.to_station_name,
          tips: "下车",
        },
      ];
    } else if (recommend.type == 2) {
      // 到达站多买
      guide.tips = `多买${recommend.diff_station_num}站`;
      guide.list = [
        {
          time: startTime,
          station: isExpectTicket
            ? recommend.expect_from_station
            : recommend.from_station_name,
          tips: "上车",
        },
        {
          line: true,
          text: "",
        },
        {
          time: arriveTime,
          station: isExpectTicket
            ? recommend.expect_to_station
            : param.to_station_name,
          tips: "下车",
        },
        {
          line: true,
          text: guide.tips,
        },
        {
          time: "",
          station: isExpectTicket
            ? param.to_station_name
            : recommend.to_station_name,
          tips: "",
        },
      ];
    } else if (recommend.type == 3) {
      // 到达站少买
      guide.tips = `补票${recommend.diff_station_num}站`;
      guide.list = [
        {
          time: startTime,
          station: isExpectTicket
            ? recommend.expect_from_station
            : recommend.from_station_name,
          tips: "上车",
        },
        {
          line: true,
          text: "",
        },
        {
          time: "",
          station: isExpectTicket
            ? param.to_station_name
            : recommend.to_station_name,
          tips: "",
        },
        {
          line: true,
          text: guide.tips,
        },
        {
          time: arriveTime,
          station: isExpectTicket
            ? recommend.expect_to_station
            : param.to_station_name,
          tips: "下车",
        },
      ];
    }
  }
  return guide;
};
